import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Dynamic } from '@shared/registry/dynamic';

import { type VisitStatusCardConfig } from './visit-status-card.types';

@Component({
  selector: 'app-visit-status-card',
  templateUrl: './visit-status-card.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Dynamic],
})
export class VisitStatusCard {
  readonly config = input.required<VisitStatusCardConfig>();

  protected readonly timeBadgeConfig = computed(() => ({
    time: this.config().time,
    label: this.config().label,
  }));

  protected readonly headerTextConfig = computed(() => ({
    text: this.config().header,
    size: 'base',
    fontWeight: 'semibold',
    color: 'var(--visitstatuscard-header-color)',
  }));

  protected readonly subheadTextConfig = computed(() => ({
    text: this.config().subhead,
    size: 'base',
    fontWeight: 'semibold',
    color: 'var(--visitstatuscard-subhead-color)',
  }));
}
